
import StarItem from './StarItem.vue';

export default {
  name: 'StarRating',
  components: { StarItem },
  props: {
    maxRating: {
      type: Number,
      default: 5,
    },
    defaultRating: {
      type: Number,
      default: 0,
    },
  },
  watch: {
    defaultRating(newValue) {
      this.rating = newValue;
    },
  },
  data() {
    return {
      rating: this.defaultRating,
      tempRating: 0,
    };
  },
  methods: {
    handleRating(rating) {
      this.rating = rating;
      this.$emit('rated', rating);
    },
    setTempRating(rating) {
      this.tempRating = rating;
    },
    clearTempRating() {
      this.tempRating = 0;
    },
    getStarState(i) {
      if (this.tempRating >= i) {
        return 'selected';
      }
      if (this.rating >= i) {
        return 'selected';
      }
      if (this.rating !== 0) {
        return 'normal';
      }
      return 'unselected';
    },
  },
};
